(function () {
  /**
   * Normalizes complex precision strings (BMPE) to a numeric value in microns.
   * Factors in base value and slope (L/xxx) at a 300mm reference length.
   */
  function parsePrecision(str) {
    if (!str || str.trim() === '') return 999;
    
    // Clean string: remove spaces, ±, parentheses
    let clean = str.replace(/[±()\s]/g, '').toLowerCase();
    
    // If multiple values exist (e.g., "2µm / 0.0001"), take the first one
    clean = clean.split('/')[0];

    let base = 0;
    let slope = 0;

    // 1. Extract base microns or inches
    // Match numbers before µm, um, μm, microns OR " , ″, '', inch, in
    const micronMatch = clean.match(/([\d.]+)(µm|um|μm|microns)/);
    const inchMatch = clean.match(/([\d.]+)(["″]|''|inch|in)/);

    if (micronMatch) {
      base = parseFloat(micronMatch[1]);
    } else if (inchMatch) {
      base = parseFloat(inchMatch[1]) * 25400; // Convert inches to microns
    } else {
      // Fallback: if no unit, these values are stored as Millimeters (mm)
      const numMatch = clean.match(/[\d.]+/);
      if (numMatch) {
        const val = parseFloat(numMatch[0]);
        // Heuristic: if < 0.1 it's likely Millimeters (e.g. 0.0012mm), 
        // if >= 0.1 it's likely already Microns or a calculated score (e.g. 3.3µm)
        if (val < 0.1) {
          base = val * 1000;
        } else {
          base = val;
        }
      }
    }

    // 2. Extract slope (L/xxx)
    // Match l/ followed by digits
    const slopeMatch = clean.match(/l\/(\d+)/);
    if (slopeMatch) {
      const divisor = parseFloat(slopeMatch[1]);
      if (divisor !== 0) {
        slope = 300 / divisor; // 300mm reference length
      }
    }

    return base + slope;
  }

  function applyFilters(wrapper) {
    const cards = wrapper.querySelectorAll('.product-card');
    const groups = wrapper.querySelectorAll('.filter-group');
    const active = {};

    groups.forEach((group) => {
      const name = group.dataset.filter;
      const badge = group.querySelector('.filter-count-badge');
      let groupActiveCount = 0;
      
      // Handle Slider Filters
      const slider = group.querySelector('.range-slider-wrap');
      if (slider) {
        const minInput = slider.querySelector('.min-range');
        const maxInput = slider.querySelector('.max-range');
        const minVal = parseFloat(minInput.value);
        const maxVal = parseFloat(maxInput.value);
        const minLimit = parseFloat(slider.dataset.min);
        const maxLimit = parseFloat(slider.dataset.max);

        if (minVal > minLimit || maxVal < maxLimit) {
          groupActiveCount = 1;
          active[name] = [{
            type: 'range',
            min: minVal,
            max: maxVal,
            isSmartPrecision: (name.includes('accuracy') || name.includes('precision') || name.includes('bmpe'))
          }];
        }
      } else {
        // Handle Pill / Button Filters
        const buttons = group.querySelectorAll('button.active');
        if (buttons.length > 0) {
          groupActiveCount = buttons.length;
          const isSmart = (name.includes('accuracy') || name.includes('precision') || name.includes('bmpe'));
          active[name] = Array.from(buttons).map((btn) => ({
            type: btn.dataset.type,
            min: parseFloat(btn.dataset.min || 0),
            max: parseFloat(btn.dataset.max || 999999),
            value: btn.dataset.value,
            isSmartPrecision: isSmart
          }));
        }
      }
      // Update active state and badge for accordion header (mobile)
      if (groupActiveCount > 0) {
        group.classList.add('has-active');
        if (badge) badge.textContent = groupActiveCount;
      } else {
        group.classList.remove('has-active');
        if (badge) badge.textContent = '';
      }
    });

    cards.forEach((card) => {
      let visible = true;

      for (const key in active) {
        const filters = active[key];
        if (!filters.length) continue;

        let match = false;
        const attrVal = card.getAttribute('data-' + key);

        for (const f of filters) {
          if (f.type === 'range') {
            // Determine if we should use smart precision parsing
            let v;
            let isSmart = f.isSmartPrecision;
            
            // Auto-detect if value looks like a precision string
            if (!isSmart && attrVal && (attrVal.includes('µm') || attrVal.includes('μm') || attrVal.includes('um') || attrVal.includes('L/') || attrVal.includes('"') || attrVal.includes('″') || attrVal.includes('in'))) {
              isSmart = true;
            }

            if (isSmart) {
              v = parsePrecision(attrVal);
            } else {
              v = parseFloat(attrVal || 0);
            }

            if (!Number.isNaN(v) && v >= f.min && v <= f.max) {
              match = true;
            }
          }

          if (f.type === 'bool') {
            if (attrVal !== null && String(attrVal) === f.value) {
              match = true;
            }
          }

          if (f.type === 'tag') {
            if (attrVal !== null) {
              const val = String(attrVal).toLowerCase();
              if (val.includes(String(f.value).toLowerCase())) {
                match = true;
              }
            }
          }
        }

        if (!match) {
          visible = false;
          break;
        }
      }

      card.style.display = visible ? '' : 'none';
    });
  }

  function toggleAccordion(header) {
    const group = header.closest('.filter-group');
    if (!group) return;

    const isOpen = group.classList.toggle('is-open');
    header.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }

  function applySort(wrapper, type) {
    const grid = wrapper.querySelector('.product-grid');
    if (!grid) return;

    const cards = Array.from(grid.children);

    cards.sort((a, b) => {
      if (type === 'price-asc') return parseFloat(a.dataset.price) - parseFloat(b.dataset.price);
      if (type === 'price-desc') return parseFloat(b.dataset.price) - parseFloat(a.dataset.price);
      if (type === 'title-asc') return String(a.dataset.title).localeCompare(String(b.dataset.title));
      if (type === 'title-desc') return String(b.dataset.title).localeCompare(String(a.dataset.title));
      return 0;
    });

    cards.forEach((card) => grid.appendChild(card));
  }

  function updateSlider(slider) {
    const minInput = slider.querySelector('.min-range');
    const maxInput = slider.querySelector('.max-range');
    const track = slider.querySelector('.slider-track');
    const minLabel = slider.querySelector('.min-label');
    const maxLabel = slider.querySelector('.max-label');
    const prefix = slider.dataset.prefix || '';
    const suffix = slider.dataset.suffix || '';

    let minVal = parseFloat(minInput.value);
    let maxVal = parseFloat(maxInput.value);

    const minPercent = ((minVal - parseFloat(minInput.min)) / (parseFloat(minInput.max) - parseFloat(minInput.min))) * 100;
    const maxPercent = ((maxVal - parseFloat(maxInput.min)) / (parseFloat(maxInput.max) - parseFloat(maxInput.min))) * 100;

    track.style.left = minPercent + "%";
    track.style.width = (maxPercent - minPercent) + "%";

    minLabel.textContent = prefix + minVal + suffix;
    maxLabel.textContent = prefix + maxVal + suffix;
  }

  // Initialize all sliders
  document.querySelectorAll('.range-slider-wrap').forEach(updateSlider);

  document.addEventListener('input', function (e) {
    const slider = e.target.closest('.range-slider-wrap');
    if (!slider) return;

    const minInput = slider.querySelector('.min-range');
    const maxInput = slider.querySelector('.max-range');

    if (e.target === minInput) {
      if (parseFloat(minInput.value) > parseFloat(maxInput.value)) {
        minInput.value = maxInput.value;
      }
    } else if (e.target === maxInput) {
      if (parseFloat(maxInput.value) < parseFloat(minInput.value)) {
        maxInput.value = minInput.value;
      }
    }

    updateSlider(slider);
  });

  document.addEventListener('change', function (e) {
    const slider = e.target.closest('.range-slider-wrap');
    if (slider) {
      const wrapper = slider.closest('.custom-filter-wrapper');
      if (wrapper) { applyFilters(wrapper); updateClearBtn(wrapper); }
      return;
    }

    const select = e.target.closest('.custom-sort');
    if (select) {
      const wrapper = select.closest('.custom-filter-wrapper');
      if (wrapper) applySort(wrapper, select.value);
    }
  });

  document.addEventListener('click', function (e) {
    // 1. Tooltip toggle handling
    const tooltipBtn = e.target.closest('.filter-tooltip-btn');
    if (tooltipBtn) {
      e.preventDefault();
      e.stopPropagation();
      const content = tooltipBtn.nextElementSibling;
      if (content && content.classList.contains('filter-tooltip-content')) {
        const isShown = content.classList.contains('show');
        document.querySelectorAll('.filter-tooltip-content.show').forEach(el => el.classList.remove('show'));
        if (!isShown) {
          content.classList.add('show');
        }
      }
      return;
    }

    // Dismiss tooltips when clicking outside
    if (!e.target.closest('.filter-tooltip-content')) {
      document.querySelectorAll('.filter-tooltip-content.show').forEach(el => el.classList.remove('show'));
    }

    // 2. Accordion Header toggle handling
    const header = e.target.closest('.filter-group-header');
    if (header) {
      e.preventDefault();
      toggleAccordion(header);
      return;
    }

    // 3. Pill button filter selection
    const btn = e.target.closest('.filter-group button:not(.filter-tooltip-btn)');
    if (!btn) return;

    e.preventDefault();
    const wrapper = btn.closest('.custom-filter-wrapper');
    if (!wrapper) return;

    btn.classList.toggle('active');
    applyFilters(wrapper);
    updateClearBtn(wrapper);
  });

  // Keyboard accessibility for accordion headers
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      const header = e.target.closest('.filter-group-header');
      if (header && !e.target.closest('.filter-tooltip-btn')) {
        e.preventDefault();
        toggleAccordion(header);
      }
    }
  });

  // ===== MOBILE: CLEAR ALL FILTERS BUTTON =====
  function updateClearBtn(wrapper) {
    const hasActive = !!wrapper.querySelector('.filter-group.has-active');
    const clearBtn = wrapper.querySelector('#mobile-clear-all-filters');
    if (clearBtn) {
      clearBtn.classList.toggle('is-visible', hasActive);
    }
  }

  document.querySelectorAll('#mobile-clear-all-filters').forEach((btn) => {
    btn.addEventListener('click', () => {
      const wrapper = btn.closest('.custom-filter-wrapper') || document.querySelector('.custom-filter-wrapper');
      if (!wrapper) return;

      // Reset all pill/button filters
      wrapper.querySelectorAll('button.active').forEach((b) => b.classList.remove('active'));

      // Reset range sliders to their min/max limits
      wrapper.querySelectorAll('.range-slider-wrap').forEach((sliderWrap) => {
        const minInput = sliderWrap.querySelector('.min-range');
        const maxInput = sliderWrap.querySelector('.max-range');
        if (minInput) {
          minInput.value = sliderWrap.dataset.min;
          minInput.dispatchEvent(new Event('input'));
        }
        if (maxInput) {
          maxInput.value = sliderWrap.dataset.max;
          maxInput.dispatchEvent(new Event('input'));
        }
      });

      applyFilters(wrapper);
      updateClearBtn(wrapper);
    });
  });

})();